import React, { useEffect, useState } from "react";
import { IonSpinner } from "@ionic/react";
import API from "../../services";
import { toast } from "react-toastify";
import { NavLink, useLocation, useNavigation } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Dialog from "@mui/material/Dialog";
import { setActiveWallet, setWallets } from "../../store/authReducer";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import CloseIcon from '@mui/icons-material/Close';
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import Strike from "../../assets/images/Strike46Logo.webp";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { getEnvVariable, Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { useTranslation } from "../../hooks/useTranslation";
import { UserDetails } from "../../models/UserDetails";

type StoreProps = {
  setActiveWallet: (data: any) => void;
  setWallets: (data: any) => void;
  userDetails?: UserDetails;
  dynamicTextColors?: any;
}

const Site: React.FC<StoreProps> = ({ setActiveWallet, setWallets, userDetails, dynamicTextColors }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [showDeposit, setshowDeposit] = useState<any>(false);
  const [siteData, setSiteData] = useState<any>();
  const [walletData, setWalletData] = useState<any>();
  const [siteWallet, setSiteWallet] = useState<any>();
  const [showWithdraw, setShowWithdraw] = useState<any>(false);
  const [siteId, setSiteId] = useState<any>("");
  const [siteProvId, setSiteProvId] = useState<any>("");
  const [amount, setAmount] = useState<number | undefined>(undefined);
  const isDisabled = loading || amount === undefined || amount <= 0;
  const [showInfo, setShowInfo] = useState(false);
  const [balance, setBalance] = useState(0);
  const [activeInfoIndex, setActiveInfoIndex] = useState<number | null>(null);
  const [show, setShow] = useState<any>(false);

  const BrandName = getEnvVariable(domain, 'BRAND_NAME')
  
  // Get dynamic text color classes from Redux instead of calling function
  const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
  const inputBoxTextColorClass = dynamicTextColors?.inputBoxTextColorClass || '';
  const buttonTextColorClass = dynamicTextColors?.buttonTextColorClass || '';

  const handleInfoClick = (index: number) => {
    setActiveInfoIndex(index);
    setTimeout(() => {
      setActiveInfoIndex(null);
    }, 5000); // 5 seconds
  };


  const getUserBalance = async () => {

    let response: any;
    try {
      response = await API.post(`/webapp/get-user-balance`, {
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (e) {
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errDescription);
    }

    if (response && response.data.wallets) {
      setWallets(response.data?.wallets);
      setActiveWallet(response?.data?.activeWallet)
      const matchingWallet = response.data?.wallets.find(
        (wallet: any) => wallet?.walletName === response.data?.activeWallet
      );
    }
  };

  const getSiteDetails = async () => {
    setLoading(true);

    let response;
    try {
      response = await API.post(`/webapp/get-site-content`, {
      });
    } catch (e) {
      console.log(e);
      setLoading(false);
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errDescription);
    }

    const sections = response.data?.sections || [];
    const wallet = response.data?.wallets || [];

    const hasFS123WithBalance = sections.some(
      (section: any) => section?.balance > 0 && section?.tgProviderId === "FS123"
    );

    if (hasFS123WithBalance) {
      toast.warn(t("sites.strike46ClosingWarning"));
      setSiteData(sections);
      setWalletData(wallet)
    }

    const hasOtherProviders = sections.some(
      (section: any) => section?.tgProviderId !== "FS123"
    );

    if (hasOtherProviders) {
      setSiteData(sections);
      setWalletData(wallet)
    }

    // if (response && response.data?.sections) {
    //   setSiteData(response.data?.sections)
    // }

    if(sections.length === 0){
      setShow(true)
    }
    setLoading(false);
  };

  const getSiteWallet = async (site: any, type: any) => {
    let response;
    try {
      response = await API.post(`/webapp/get-site-wallet`, {
        tgProviderId: site?.tgProviderId
      });
    } catch (e) {
      console.log(e);
      return;
    }

    setSiteId(site?.id)
    setSiteProvId(site?.tgProviderId)

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errDescription);
    }

    if (response && response.data) {
      setSiteWallet(response.data)
      if (type === "deposit") {
        setshowDeposit(true);
      } else {
        setShowWithdraw(true)
      }
    }
  };

  useEffect(() => {
    getSiteDetails();
    sessionStorage.setItem("previousPath", location.pathname);
  }, []);

  // useEffect(() => {
  //   if(amount >= 1){

  //   }
  // },[amount])

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (amount === undefined) return; // Ensure amount is provided

    if (amount > (siteWallet?.walletBalance - siteWallet?.walletExposure)) {
      toast.error(t("sites.amountCannotBeGreaterThanUserWallet"));
      return
    }

    setLoading(true);
    try {
      const response = await API.post(`/webapp/site-deposit`, {
        amount: amount,
        siteId: siteId,
        tgProviderId: siteProvId,
      });

      const data = response.data;
      if (data.status !== "RS_OK") {
        toast.error(`${data.errDescription}`);
        return;
      } else {
        toast.success(t("sites.depositSuccessful"));
        setshowDeposit(false);
        setAmount(0);
        getSiteDetails();
        getUserBalance();
      }



    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleWithDrawSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (amount === undefined) return; // Ensure amount is provided

    if (amount > (siteWallet?.siteBalance - siteWallet?.siteExposure)) {
      toast.error(t("sites.amountCannotBeGreaterThanSiteBalance"));
      return
    }

    setLoading(true);
    try {
      const response = await API.post(`/webapp/site-withdraw`, {
        amount: amount,
        siteId: siteId,
        tgProviderId: siteProvId,
      });

      const data = response.data;
      if (data.status !== "RS_OK") {
        toast.error(`${data.errDescription}`);
        return;
      } else {
        toast.success(t("sites.withdrawalSuccessful"));
        setShowWithdraw(false);
        setAmount(0);
        getSiteDetails();
        getUserBalance();
      }

    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="flex flex-col mt-4 w-full md:max-w-7xl md:mx-auto md:px-6 site">
        {

          loading ? (
            <div className="home-loading">
              <img src={Loader(domain)} style={{ height: '10rem' }} />
            </div>
          ) : (
            <>
              {walletData && walletData.length > 0 ? (
                <div className="flex flex-col gap-4">
                  {(() => {
                    // Group sections by integratorId while maintaining order
                    const groupedSections: { [key: string]: any[] } = {};
                    const sectionOrder: string[] = [];
                    
                    siteData?.forEach((section: any) => {
                      const integratorId = section?.integratorId || 'no-wallet';
                      if (!groupedSections[integratorId]) {
                        groupedSections[integratorId] = [];
                        sectionOrder.push(integratorId);
                      }
                      groupedSections[integratorId].push(section);
                    });

                    return sectionOrder.map((integratorId, groupIndex) => {
                      const matchingSites = groupedSections[integratorId] || [];
                      // Find wallet that matches this integratorId
                      const matchingWallet = walletData?.find((wallet: any) => 
                        wallet?.integratorId === integratorId
                      );

                      // If no matching wallet, skip this group
                      if (!matchingWallet && integratorId !== 'no-wallet') {
                        return null;
                      }

                      return (
                        <div
                          key={groupIndex}
                          className="border border-border-color rounded-lg p-4 bg-inputbox-color"
                        >
                          {/* Wallet Balance and Exposure */}
                          {matchingWallet && (
                            <>
                              <div className={`flex justify-between text-sm mb-3 ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                <span>{t("common.balance")}: {matchingWallet?.balance ?? 0}</span>
                                <span>{t("common.exposure")}: {matchingWallet?.exposure ?? 0}</span>
                              </div>

                              {/* Send and Receive Buttons */}
                              {matchingSites.length > 0 && (
                                <div className={`flex relative gap-[4%] justify-center mt-2 mb-3 text-sm font-medium whitespace-nowrap ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
                                  <button
                                    className={`py-1 rounded-lg w-[40%] bg-border-color border border-border-color ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                    onClick={() => getSiteWallet(matchingSites[0], "deposit")}
                                  >
                                    {t("sites.send")}
                                  </button>
                                  <button
                                    className={`py-1 rounded-lg w-[40%] bg-border-color border border-border-color ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                    onClick={() => getSiteWallet(matchingSites[0], "withdraw")}
                                  >
                                    {t("sites.receive")}
                                  </button>
                                </div>
                              )}
                            </>
                          )}

                          {/* Display matching sites */}
                          {matchingSites.length > 0 && (
                            <div className="flex flex-col gap-3 mt-3">
                              {matchingSites.map((section: any, siteIndex: number) => (
                                <div
                                  key={siteIndex}
                                  className={`relative w-full text-left font-medium rounded-lg ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                                >
                                  <NavLink
                                    to={`/play/${btoa(`${section?.id || ""}::${section?.tgProviderId}:::site::::`)}`}
                                    className="nav-link"
                                  >
                                    <div className="flex items-center justify-center w-full">
                                      <div className="w-[95%] lg:w-[40%] h-auto overflow-hidden bg-gray-800 flex items-center justify-center rounded-md">
                                        <img 
                                          src={section?.id === "strike46new" && BrandName === "ApexWin" ? "https://cdn.stwin2025.co/TG/BotYaPot/site_logos/apexwin.webp" 
                                            : section?.id === "strike46new" && BrandName === "JkBetsWin" ? "https://cdn.stwin2025.co/TG/BotYaPot/site_logos/jkbets.webp" 
                                            : (section?.thumbnail || Strike)} 
                                          alt={section?.name || "site"} 
                                          className="w-full h-full object-contain"
                                        />
                                      </div>
                                    </div>
                                  </NavLink>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    });
                  })()}
                </div>
              ) : (
                <>
                  {siteData && siteData.length > 0 ? (
                    <>
                      {siteData?.map((section: any, index: number) => (
                        <div
                          key={index}
                          className={`relative w-full px-4 text-left font-medium rounded-lg ${
                            index !== siteData.length - 1 ? 'mb-4' : ''
                          } ${pageTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        >
                          <NavLink
                            to={`/play/${btoa(`${section?.id || ""}::${section?.tgProviderId}:::site::::`)}`}
                            className="nav-link"
                          >
                            <div className="flex items-center justify-center w-full">
                              <div className="w-[95%] lg:w-[40%] h-auto overflow-hidden bg-gray-800 flex items-center justify-center rounded-md">
                                <img 
                                 src={section?.id === "strike46new" && BrandName === "ApexWin" ? "https://cdn.stwin2025.co/TG/BotYaPot/site_logos/apexwin.webp" : (section?.thumbnail || Strike)} 
                                  alt={section?.name || "site"} 
                                  className="w-full h-full object-contain"
                                />
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {show && (
                        <div className={`mb-3 text-sm font-medium text-center ${pageTextColorClass === 'dark-text' ? 'text-yellow-600' : 'text-yellow-400'}`}>
                          {t("sites.newSitesComingSoon")}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )
        }
      </div>
      {
        showDeposit && (
          <Dialog
            fullScreen={false}
            open={showDeposit}
            onClose={() => {
              setshowDeposit(false);
              setAmount(0);
            }}
            PaperProps={{
              style: {
                position: 'absolute',
                top: '5rem'
              }
            }}
          >
            <div className="dialog-bg bg-inputbox-color relative p-4">
              {/* Close Button */}
              <CloseIcon
                className={`absolute top-3 right-3 text-2xl font-semibold ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                onClick={() => { setshowDeposit(false); setAmount(0) }}
              />
              <div>
                <div className={inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}>
                  {t("sites.availableBalance")} {(siteWallet?.walletBalance - siteWallet?.walletExposure).toFixed(2)}
                </div>
                <div>
                  <>
                    <form className="flex flex-col w-full" onSubmit={handleSubmit}>
                      <label
                        htmlFor="amount"
                        className={`block mt-3 text-sm ${pageTextColorClass === 'dark-text' ? 'text-gray-600' : 'text-zinc-400'}`}
                      >
                        {t("common.amount")}
                      </label>
                      <input
                        type="number"
                        id="amount"
                        className={`px-4 py-3 mt-2.5 w-full text-sm font-medium placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        placeholder={t("sites.enterYourAmount")}
                        value={amount || ""}
                        onChange={(e) => setAmount(Number(e.target.value))}
                      />

                      <div className="flex justify-between mt-4">
                        <button
                          type="submit"
                          className={`p-2.5 w-[48%] text-sm bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        >
                          {t("sites.send")}
                        </button>
                        <button
                          type="button"
                          className={`p-2.5 w-[48%] text-sm bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem] ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                          onClick={() => { setshowDeposit(false); setAmount(0) }}
                        >
                          {t("sites.cancel")}
                        </button>
                      </div>
                    </form>
                  </>
                </div>
              </div>
            </div>
          </Dialog>
        )
      }
      {
        showWithdraw && (
          <Dialog
            fullScreen={false}
            open={showWithdraw}
            onClose={() => {
              setShowWithdraw(false)
              setAmount(0);
            }}
            PaperProps={{
              style: {
                position: 'absolute',
                top: '5rem'
              }
            }}
          >
            <div className="dialog-bg bg-inputbox-color relative p-4">
              <CloseIcon
                className={`absolute top-3 right-3 text-2xl font-semibold ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                onClick={() => { setShowWithdraw(false); setAmount(0) }}
              />
              <div>
                <div className={inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}>
                  {t("sites.availableBalance")} {(siteWallet?.siteBalance - siteWallet?.siteExposure).toFixed(2)}
                </div>
                <div>
                  <>
                    <form className="flex flex-col w-full" onSubmit={handleWithDrawSubmit}>
                      <label
                        htmlFor="amount"
                        className={`block mt-3 text-sm ${pageTextColorClass === 'dark-text' ? 'text-gray-600' : 'text-zinc-400'}`}
                      >
                        {t("common.amount")}
                      </label>
                      <input
                        type="number"
                        id="amount"
                        className={`px-4 py-3 mt-2.5 w-full text-sm font-medium placeholder:text-text-color whitespace-nowrap rounded-lg border border-solid bg-inputbox-color border-border-color focus:outline-none leading-[1.4rem] ${inputBoxTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        placeholder={t("sites.enterYourAmount")}
                        value={amount || ""}
                        onChange={(e) => setAmount(Number(e.target.value))}
                      />

                      <div className="flex justify-between mt-4">
                        <button
                          type="submit"
                          className={`p-2.5 w-[48%] text-sm bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                        >
                          {t("sites.receive")}
                        </button>
                        <button
                          type="button"
                          className={`p-2.5 w-[48%] text-sm bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem] ${buttonTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                          onClick={() => { setShowWithdraw(false); setAmount(0) }}
                        >
                          {t("sites.cancel")}
                        </button>
                      </div>
                    </form>
                  </>
                </div>
              </div>
            </div>
          </Dialog>
        )
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setWallets: (data: any) => {
      dispatch(setWallets(data));
    },
    setActiveWallet: (data: any) => {
      dispatch(setActiveWallet(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Site);
